import React, { useState } from "react";
import { CALLBACK_SOURCE_SCREEN, NUMBER } from "../../../constants/app-constants";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { checkoutCallbackRequest } from "../checkout-info/actions";
import styles from "./styles.css";
import { REQUEST_CALLBACK_SOURCE } from "../../../constants/checkout-constants";
import { Alert } from "@cars24/turbo-web/lib/alert";

const withCallbackRequest = (Component, sourceScreen = CALLBACK_SOURCE_SCREEN.LENDER_DETAILS, params = {}) => {
    const WithCallbackRequest = (props) => {
        const [showRequestAlreadyReceivedModal, setShowRequestAlreadyReceivedModal] = useState(false);
        const [showRequestAlreadyReceivedModalText, setShowRequestAlreadyReceivedModalText] = useState(false);
        const { checkoutCallbackRequestConnect, checkoutCallbackRequestExpired, mobile, callbackRequest } = props;
        const showDLSToast = sourceScreen === REQUEST_CALLBACK_SOURCE.BYOF;

        const handleCallbackRequest = async () => {
            if (!checkoutCallbackRequestExpired) {
                setShowRequestAlreadyReceivedModalText(true);
                window.setTimeout(() => {
                    setShowRequestAlreadyReceivedModalText(false);
                }, NUMBER.THREE_THOUSAND);
            } else {
                try {
                    //get screen name
                    await checkoutCallbackRequestConnect(sourceScreen, params);
                    setShowRequestAlreadyReceivedModal(true);
                    window.setTimeout(() => {
                        setShowRequestAlreadyReceivedModal(false);
                    }, NUMBER.FOUR_THOUSAND_FIVE_HUNDRED);
                } catch (error) {
                    //console.log(error);
                }
            }
        };

        const getToast = (message) => {
            if (showDLSToast) {
                return (
                    <div styleName={"styles.alertmsgBox"}>
                        <Alert
                            heading={message}
                            showClose={false}
                            subHeading={null}
                            type="info"
                            priority="low"
                        />
                    </div>
                );
            }

            return (
                <div styleName={"styles.alertmsgBox"}>
                    <p styleName={"styles.requestRaised"}>{message}</p>
                </div>
            );
        };

        return (
            <React.Fragment>
                <Component {...props} handleCallbackRequest={handleCallbackRequest} callbackRequest={callbackRequest} />
                {showRequestAlreadyReceivedModal && getToast(`We will give you a call on ${mobile} shortly`)}

                {showRequestAlreadyReceivedModalText && getToast("Request already received. Please wait for our call")}
            </React.Fragment>
        );
    };
    const mapStateToProps = ({
        carDetails: { config },
        user: { mobile },
        checkout: {
            callbackDetails: { isExpired, requested }
        }
    }) => ({
        config,
        mobile,
        checkoutCallbackRequestExpired: isExpired,
        callbackRequest: requested
    });

    const mapDispatchToProps = (dispatch) =>
        bindActionCreators(
            {
                checkoutCallbackRequestConnect: checkoutCallbackRequest
            },
            dispatch
        );

    WithCallbackRequest.propTypes = {
        checkoutCallbackRequestConnect: PropTypes.func,
        checkoutCallbackRequestExpired: PropTypes.bool,
        mobile: PropTypes.string,
        callbackRequest: PropTypes.bool
    };
    return connect(mapStateToProps, mapDispatchToProps)(WithCallbackRequest);
};

export default withCallbackRequest;
